export { RemoveFormat } from '@ckeditor/ckeditor5-remove-format'
